import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../api'

const initialState = {
    data: [],
    error: '',
    loading: false,
    isPlaying: false,
};

const historyUrl = 'http://20.102.45.175:8300/api/history';

export const getHistory = createAsyncThunk(
    'history/getHistory',
    async () => {
        const res = await axios.get('/history');
        return res.data;
    }
);

export const deleteVoice = createAsyncThunk(
    'history/deleteVoice',
    async (data) => {
        const userToken = store.getState().auth.login.data.access_token
        const token = `Bearer ${userToken}`
        console.log('wavename in redux', data);
        console.log('token in redux', token);
        const res = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/wave/delete/${data.wav_name}`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
            }
        );
        return res.data;
    }

);


export const historySlice = createSlice({
    name: 'history',
    initialState,
    reducers: {
        setIsPlaying: (state, action) => {
            state.isPlaying = action.payload;
        },
    },
    extraReducers: {
        [getHistory.pending]: (state) => {
            state.loading = true;
        },
        [getHistory.fulfilled]: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        [getHistory.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [deleteVoice.pending]: (state) => {
            state.loading = true;
        },
        [deleteVoice.fulfilled]: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        [deleteVoice.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const { setIsPlaying } = historySlice.actions;

export const selectHistory = (state) => state.history;
export default historySlice.reducer;


